import React from 'react';
import PropTypes from 'prop-types';
import { Cover, FAQs, IconsWithText, Layout, Link, SectionNumbered, SEO, SectionReviewModals } from 'components';
import { routes } from 'utils/routes';
import { cta } from 'utils/cta';
import { media } from "utils/media";

// Content
import contentSEO from "cms/content/guarantee-seo.yml";
import contentCover from "cms/content/guarantee-cover.yml";
import contentIcons from "cms/content/guarantee-icons-with-text.yml";
import contentSectionOne from "cms/content/guarantee-section-one.yml";
import contentSectionTwo from "cms/content/guarantee-section-two.yml";
import contentSectionThree from "cms/content/guarantee-section-three.yml";
import contentSectionFour from "cms/content/guarantee-section-four.yml";
import contentSecReviewModals from "cms/content/guarantee-section-review-modals.yml"
import contentFaqs from "cms/content/guarantee-faqs.yml"

const GuaranteesPage = ({ pageContext: { locale }, location }) => (
  <Layout locale={locale} className='guarantee-wrapper'>
    <SEO
      title={contentSEO.title}
      description={contentSEO.description}
      lang={locale}
      keywords={contentSEO.keywords}
      location={location}
      image={contentSEO.socialImage}
    />

    <Link to={routes.apart.path} {...routes.apart} className='cta-sidetab'>What sets us apart?</Link>

    <Cover
      title={contentCover.title}
      text={contentCover.text}
      image={{ url: media(contentCover.image), alt: 'Straight teeth guarantees to make you smile' }}
      button={{ label: cta.getStarted, ...routes.getStarted }}
      overlap={contentCover.overlap}
      trustpilot={contentCover.trustpilot}
      stamp={contentCover.stamp}
    />

    <IconsWithText content={contentIcons} />

    <div className='section-numbered-wrapper'>
      <SectionNumbered locale={locale} content={contentSectionOne} />
      <SectionNumbered locale={locale} content={contentSectionTwo} />
      <SectionNumbered locale={locale} content={contentSectionThree} />
      <SectionNumbered locale={locale} content={contentSectionFour} />
    </div>

    {contentFaqs.enabled && <FAQs title='' faqsData={contentFaqs['faqs']} className='mb-50 mt-90 inc-font-size' locale={locale} />}

    <SectionReviewModals content={contentSecReviewModals} />
  </Layout>
);

GuaranteesPage.propTypes = {
  pageContext: PropTypes.shape({
    locale: PropTypes.string.isRequired,
  }).isRequired,
};

export default GuaranteesPage;
